import React from 'react'

function IconCalendar() {
  return <svg className="icon icon--calendar">
    <use xlinkHref="#icon-calendar" />
  </svg>
}

export default IconCalendar
